__turbopack_context__.v({
  "complete": "CompleteList-module__ZD2gUq__complete",
  "dates": "CompleteList-module__ZD2gUq__dates",
  "item": "CompleteList-module__ZD2gUq__item",
  "list": "CompleteList-module__ZD2gUq__list",
  "marker": "CompleteList-module__ZD2gUq__marker",
});
